import React from 'react'

import BreadcrumbsUI5 from "../../../core/gd-components/breadcrumbs/breadcrumbs-ui5"
import Starred from "../../../core/gd-app/component/quick-links/starred"
import UI5ControlButton from "../../app-controls/buttons/button/button"
import Pin from "../../../core/gd-components/pin/v2/pin";
import ControlButtonClose from "../../../core/gd-components/buttons/control-button/close";

type Props = {
    icon?           : string,
    title?          : string,
    titleParent?    : string
    projectId?      : string,
    leftContent?    : any,

    starData?       : any,
    pinData?        : any,
    minimizeData?   : any,

    disabled?       : boolean

    onCloseClick?   : {(e?:any):void},
}

export default function ItemViewTop(props:Props) {

    let content
    if (props.leftContent) {
        content = props.leftContent
    } else if (props.titleParent) {
        content = (
            <div className="ui5-breadcrumbs">
                <div className="item">
                    {props.titleParent}
                </div>
                <div className="separator"/>
                <div className="item">
                    <div className={Classes("ui5-ico-13 m-r-5", props.icon)}/>
                    <div className="ui5-txt-not-important-small">{props.title}</div>
                </div>
            </div>
        )
    } else if (props.projectId) {
        content = <BreadcrumbsUI5 projectId     = {props.projectId}
                                  maxParents    = {2}
                                  disabled      = {props.disabled}/>
    } else {
        content = (
            <React.Fragment>
                {props.icon && <div className={Classes("ui5-ico-13 m-r-5", props.icon)}/>}
                <div className="ui5-txt-not-important-small">{props.title}</div>
            </React.Fragment>
        )
    }

    const onMinimizeClick = (e:any) => {
        if (props.minimizeData.taskId) {
            gd.taskTray.add(props.minimizeData.taskId, props.minimizeData.taskTitle);
        } else if (props.minimizeData.chatId) {
            gd.taskTray.addChat(props.minimizeData.chatId, props.minimizeData.chatTitle, props.minimizeData.type);
        }
        props.onCloseClick && props.onCloseClick(e)
    }

    const onCloseClick = () => {
        props.onCloseClick && props.onCloseClick()
    }

    return (
        <div className="iv-top">

            <div className="left">
                {content}
            </div>

            <div className="right">
                {props.starData &&
                    <Starred className="m-r-5" renderType="ui5" params={props.starData} />
                }

                {props.pinData &&
                    <Pin className="m-r-5" data = {props.pinData}/>
                }

                {props.minimizeData &&
                    <UI5ControlButton iconClass="i5-minimize m-r-5" fontSize="14" onClick={onMinimizeClick} hint="Minimize view to tray" />
                }

                <ControlButtonClose onClick={onCloseClick} />

            </div>
        </div>
    )
}